import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import Loader from 'components/Loader';

// ==============================|| AUTH GUARD ||============================== //
// Protects MainRoutes (routes/MainRoutes.jsx) - the do-ra.cz backend is a
// closed system (docs/ARCHITECTURE.md), nothing here is meant to render
// without a real session.

export default function AuthGuard({ children }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') return <Loader />;

  if (status !== 'authenticated') {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return children;
}

AuthGuard.propTypes = { children: PropTypes.node };
